export const callInit = 'callInit';
export const mediaSetup = 'mediaSetup';
export const sessionSetup = 'sessionSetup';
export const callDuration = 'callDuration';
export const waitingRoom = 'waitingRoom';
export const troubleshooting = 'troubleshooting';
export const precallTest = 'precallTest';
export const callReconnecting = 'callReconnecting';
export const photoCapture = 'photoCapture';
export const photoCaptureService = 'photoCaptureService';
export const callHold = 'callHold';
